<style lang="scss">

</style>

<template>
  <div v-if="!loading" class="full-width" :style="{maxWidth: maxWidth || 'unset'}">
    <apexchart :options="chartOptions" :type="chartOptions.type" :series="series" />
  </div>
</template>

<script>
  /**
   * This chart comp is used when there is a lot of pre-filled options
   * to set to save repeating them in lots of components
   */
  export default {
    name: 'Chart',
    components: {},
    props: {
      // eslint-disable-next-line vue/require-default-prop
      maxWidth: {
        required: false,
        type: String,
      },
      // eslint-disable-next-line vue/require-default-prop
      type: {
        required: false,
        type: String,
      },
      series: {
        required: true,
        type: Array,
      },
      // eslint-disable-next-line vue/require-default-prop
      xAxis: {
        required: false,
        type: Object,
      },
      // eslint-disable-next-line vue/require-default-prop
      yAxis: {
        required: false,
        type: Object,
      },
      // eslint-disable-next-line vue/require-default-prop
      colors: {
        required: false,
        type: Array,
      },
      // eslint-disable-next-line vue/require-default-prop
      xTitle: {
        required: false,
        type: String,
      },
      // eslint-disable-next-line vue/require-default-prop
      yTitle: {
        required: false,
        type: String,
      },
      // eslint-disable-next-line vue/require-default-prop
      title: {
        required: false,
        type: String,
      },
      // eslint-disable-next-line vue/require-default-prop
      yAnnotate: {
        required: false,
        type: Object,
      },
    },
    data() {
      return {
        loading: true,
        chartOptions: {
          colors: ['#7B2DA4'],
          title: {
            text: '',
            align: 'center',
          },
          chart: {
            width: '100%',
            type: 'bar',
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
              },
              export: {
                csv: {
                  filename: 'chart',
                },
              },
            },
            events: {},
          },
          series: [],
          xaxis: {
            type: 'category',
            title: {
              text: '',
              style: {
                color: '#000000',
              },
            },
          },
          yaxis: {
            title: {
              text: '',
              style: {
                color: '#000000',
              },
            },
          },
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150,
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350,
            },
          },
          annotations: {
            yaxis: [
              {
                y: null,
                borderColor: '#283897',
                label: {
                  borderColor: '#283897',
                  style: {
                    color: '#fff',
                    background: '#283897',
                  },
                  text: '',
                },
              },
            ],
          },
        },
      };
    },
    mounted() {
      this.setUpChart();
    },
    methods: {
      setUpChart() {
        this.chartOptions.chart.type = this.type || this.chartOptions.chart.type;
        this.chartOptions.series = this.series || this.chartOptions.series;
        this.chartOptions.xaxis = this.xAxis || this.chartOptions.xaxis;
        this.chartOptions.yaxis = this.yAxis || this.chartOptions.yaxis;
        this.chartOptions.colors = this.colors || this.chartOptions.colors;
        this.chartOptions.xaxis.title.text = this.xTitle || '';
        this.chartOptions.yaxis.title.text = this.yTitle || '';
        this.chartOptions.title.text = this.title || '';

        if (this.yAnnotate) {
          this.chartOptions.annotations.yaxis[0].y = this.yAnnotate.value || null;
          this.chartOptions.annotations.yaxis[0].label.text = this.yAnnotate.text || null;
        }

        this.chartOptions.chart.events = {
          dataPointSelection: (event, chartContext, config) => {
            this.$emit('data-clicked', config);
          },
        }

        this.loading = false;
      },
    },
  };
</script>
